<div class="dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{ 'sebbie_ranking.promotion_action' | translate }}</span>
      <button class="close-ref" mat-icon-button (click)="close()" [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div mat-dialog-content>
        <div class="description">
            <h3>{{ promotionAction.title }}</h3>
            <div class="date">
                <mat-icon>event_available</mat-icon>
                <div class="date-text">
                    <span 
                        [title]="promotionAction.startDate| date: 'dd-MM-yy'"
                    >
                        {{ promotionAction.startDate | date: "dd-MM-yy" }}
                    </span>
                    {{ "general.to" | translate }}
                    <span 
                        [title]="promotionAction.expirationDate | date: 'dd-MM-yy'"
                    >
                        {{ promotionAction.expirationDate | date: "dd-MM-yy" }}
                    </span>
                </div>
            </div>
            <p>{{ promotionAction.description}}</p>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-button-end">
      <button class="close-ref cancel" mat-flat-button color="primary" [title]="'general.close' | translate | titlecase" (click)="close()">
        {{ 'general.close' | translate}}
      </button>
    </div>
</div>
